var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStepperDoneV2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#DDEFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1545 10.3301C20.9501 10.1449 20.6807 10.0485 20.4053 10.0618C20.1299 10.0751 19.871 10.1971 19.6855 10.4011L13.3414 17.3871L10.2764 14.2711C10.0819 14.08 9.82014 13.9731 9.54749 13.9732C9.27484 13.9732 9.01314 14.0804 8.81871 14.2715C8.62429 14.4627 8.51269 14.7225 8.50797 14.9951C8.50325 15.2677 8.60578 15.5313 8.79346 15.7291L12.6305 19.6291C12.7271 19.7275 12.8424 19.8057 12.9697 19.8591C13.0969 19.9125 13.2335 19.94 13.3714 19.9401H13.3915C13.5331 19.9372 13.6727 19.9056 13.8016 19.8469C13.9306 19.7883 14.0462 19.7039 14.1415 19.5991L21.2255 11.7991C21.4106 11.5947 21.5071 11.3253 21.4938 11.0499C21.4805 10.7745 21.3584 10.5156 21.1545 10.3301V10.3301Z",
    fill: "#255E8E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#C2DAF0",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStepperDoneV2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stepper-done-v2.7ebb1c1c.svg";
export { ForwardRef as ReactComponent };